<div class="search-fields">
  <div class="form-section">
    <input class="btn" type="submit" value="" name="submit" tabindex="-1" />
    <input class="form-control tab-focus" type="text" placeholder="What medication are you looking for?"
      (click)="onSearchClick($event)"
      (keydown)="onSearchKeydown($event)"
      (keyup)="onSearchKeyup($event)" (focus)="onSearchFocus()"
      (blur)="clearHeight(); getCardShow()" value="{{ SelectedDrug }}" [(ngModel)]="SelectedDrug" id="SearchDrugText"
      autocomplete="off" [attr.tabindex]="searchInputTabIndex"
      role="combobox" [attr.aria-expanded]="isDropdownOpen()" aria-controls="search-dropdown-list"
      [attr.aria-activedescendant]="dropdownActiveIndex >= 0 ? 'search-dropdown-item-' + dropdownActiveIndex : null" />
    <!-- <div *ngIf="errorShowDisplay">
      <span class="errorSearchMsg"
        ><span>{{ searchtextbox_error }}</span></span
      >
    </div> -->
    <!-- <span  [className]="errorShowDisplay ? 'errorSearchMsg' : ''"><span>{{ searchtextbox_error }}</span></span> -->
    <div class="serachlist" *ngIf="ShowDisplay">
      <div class="recent_sesrch" *ngIf="ShowRecentSearch">
        <div class="title nodrugfound" style="color:red" *ngIf="NoDrugsFound">
          <span>Oops! Something is wrong</span>
          <p>There are no items found with this search. Double check your prescription.</p>
        </div>
        <div class="title heading" id="RS">Recent Searches</div>
        <ul id="search-dropdown-list">
          <li *ngFor="let item of SearchItemArray; let i = index" [id]="'search-dropdown-item-' + i"
            [class.dropdown-active]="isDropdownItemActive(i, 'recent')" (focusout)="setHeight('focusout')"
            (click)="DrugSetting(item.text)" role="option" [attr.aria-selected]="isDropdownItemActive(i, 'recent')">
            {{ item.text }}
          </li>
          <!-- <li>Atorvastatin ( <span>Generic Lipitor</span> )</li>
            <li>Atenolol ( Generic Tenormin )</li> -->
        </ul>
      </div>
    </div>

    <!---List based on user typed drug-->
    <div class="serachlist" *ngIf="DisplayBindList">
      <ul id="search-dropdown-list">
        <li *ngFor="let item of SearchList; let i = index" [id]="'search-dropdown-item-' + i"
          [class.dropdown-active]="isDropdownItemActive(i, 'search')" (click)="DrugSetting(item.DrugName)"
          role="option" [attr.aria-selected]="isDropdownItemActive(i, 'search')">
          {{ item.DrugName }}
        </li>
      </ul>
    </div>
    <div class="search_btn btn lowest btnshover tab-focus" [attr.tabindex]="searchButtonTabIndex" role="button"
      (keydown)="onFindLowestPriceKeydown($event)" (click)="ClickDrug()">
      Find Lowest Price
    </div>
  </div>
</div>
<!-- Popular List -->
<div class="popular_sesrch">
  <div class="title heading" id="PS" style="display: block;">
    Popular Searches
  </div>
  <ul>
    <li *ngFor="let item of PopularDrugs; let i = index" class="tab-focus" role="button"
      [attr.tabindex]="getPopularSearchTabIndex(i)" (click)="DrugSetting(item.DisplayName)"
      (keydown)="onPopularSearchKeydown($event)">
      {{ item.DrugName }}
    </li>
  </ul>
</div>
<!--Search pharmacy popup-->
<!-- <div class="search_pharmacy_popup" *ngIf="ShowDrugdetails"> -->
<div class="search_pharmacy_popup" *ngIf="ShowDrugdetails">
  <div class="search_pharmacy_select">
    <!-- <h2>Atenolol ( Generic Tenormin )</h2> -->
    <!-- <h2>{{ SelectedDrug }}</h2> -->
    <h2>Search Details</h2>
    <div class="filter_box">
      <div class="close_search_pharmacy_popup tab-focus" data-popup-tab [attr.tabindex]="POPUP_TAB.CLOSE"
        role="button" aria-label="Close" (click)="CloseDrugDetails()"
        (keydown)="onCloseSearchPopupKeydown($event)"></div>
      <div class="lists_box" [ngClass]="{ singleDoseForm: DrugNameTypeSingle }">
        <div class="tab-focus" [class.dropdown-open]="hideme[0]"
          [attr.data-popup-tab]="popupPanelTabIndex(0) >= 0 ? '' : null"
          [attr.tabindex]="popupPanelTabIndex(0)" [attr.aria-disabled]="DrugNameTypeSingle || null" role="button"
          (keydown)="onPopupTriggerKeydown($event, 0)"
          (click)="onPopupTriggerClick($event, 0)">
          <label>Type</label>
          <div class="filtertext">
            {{ SelectedDrug }}
          </div>
          <i></i>
        </div>
        <div class="lists" [hidden]="!hideme[0]">
          <label>Type</label>
          <div class="filtertext">
            {{ SelectedDrug }}
          </div>
          <ul>
            <li *ngFor="let item of drugTypeListItems; let i = index" [id]="'popup-list-item-0-' + i"
              (click)="addActive_select($event, 0, item, '')"
              [ngClass]="{ active: isPopupListItemActive(0, i, item) }">
              {{ item }}
            </li>
            <!-- <li>None</li>
                  <li>Atenolol</li>
                  <li>Atenolol</li>
                  <li>Atenolol</li> -->

          </ul>
          <div class="closepop" (click)="hideme[0] = !hideme[0]; $event.stopPropagation()"></div>
        </div>
      </div>
      <div class="lists_box" [ngClass]="{ singleDoseForm: DrugFormSingle }">
        <div class="tab-focus" [class.dropdown-open]="hideme[1]"
          [attr.data-popup-tab]="popupPanelTabIndex(1) >= 0 ? '' : null"
          [attr.tabindex]="popupPanelTabIndex(1)" [attr.aria-disabled]="DrugFormSingle || null" role="button"
          (keydown)="onPopupTriggerKeydown($event, 1)"
          (click)="onPopupTriggerClick($event, 1)">
          <label>Form</label>
          <div class="filtertext">
            {{ DrugType }}
          </div>
          <i></i>
        </div>
        <div class="lists formm" [hidden]="!hideme[1]">
          <label>Form</label>
          <div class="filtertext">
            {{ DrugType }}
          </div>
          <ul>
            <li *ngFor="let item of optionlist; let i = index" [id]="'popup-list-item-1-' + i"
              (click)="addActive_select($event, 1, item.text, '')"
              [ngClass]="{ active: isPopupListItemActive(1, i, item) }">
              {{ item.text }}
            </li>
          </ul>
          <div class="closepop" (click)="hideme[1] = !hideme[1]; $event.stopPropagation()"></div>
        </div>
      </div>
      <div class="lists_box" [ngClass]="{ singleDoseForm: DrugDoseSingle }">
        <div class="tab-focus" [class.dropdown-open]="hideme[2]"
          [attr.data-popup-tab]="popupPanelTabIndex(2) >= 0 ? '' : null"
          [attr.tabindex]="popupPanelTabIndex(2)" [attr.aria-disabled]="DrugDoseSingle || null" role="button"
          (keydown)="onPopupTriggerKeydown($event, 2)"
          (click)="onPopupTriggerClick($event, 2)">
          <label>Dosage</label>
          <div class="filtertext">
            {{ DrugDose }}
          </div>
          <i></i>
        </div>
        <div class="lists" [hidden]="!hideme[2]">
          <label>Dosage</label>
          <div class="filtertext">
            {{ DrugDose }}
          </div>
          <ul>
            <li *ngFor="let item of DrugDoseList; let i = index" [id]="'popup-list-item-2-' + i"
              (click)="addActive_select($event, 2, item, '')"
              [ngClass]="{ active: isPopupListItemActive(2, i, item) }">
              {{ item }}
            </li>

          </ul>
          <div class="closepop" (click)="hideme[2] = !hideme[2]; $event.stopPropagation()"></div>
        </div>
      </div>
      <div class="lists_box">
        <div class="tab-focus" [class.dropdown-open]="hideme[3]"
          [attr.data-popup-tab]="popupPanelTabIndex(3) >= 0 ? '' : null"
          [attr.tabindex]="popupPanelTabIndex(3)" role="button"
          (keydown)="onPopupTriggerKeydown($event, 3)"
          (click)="onPopupTriggerClick($event, 3)">
          <label>Quantity</label>
          <div class="filtertext">
            {{ DrugQuant }}
          </div>
          <i></i>
        </div>
        <div class="lists" [hidden]="!hideme[3]">
          <label>Quantity</label>
          <div class="filtertext">
            {{ DrugQuant }}
          </div>
          <ul>
            <li *ngFor="let item of DrugQuantityList; let i = index" [id]="'popup-list-item-3-' + i"
              (click)="addActive_select($event, 3, item, item.NDCCode)"
              [ngClass]="{ active: isPopupListItemActive(3, i, item) }">
              {{ item.DisplayQuantity }}
            </li>
            <!-- <li (click)="addActive_select($event, -3, QuantityManual)">
              Enter a Quantity
            </li> -->

          </ul>
          <div class="closepop" (click)="hideme[3] = !hideme[3]; $event.stopPropagation()"></div>
        </div>
      </div>
      <div class="lists_box PharmacyNear">
        <div>
          <label>Pharmacies Near</label>

          <!-- <div class="filtertext">Oakland, CA 94618, USA</div> -->
          <div class="filtertext clearfix pharmacy-zip-row">
            <input id="search_popup_zipcode" type="tel" class="tab-focus" data-popup-tab placeholder="Type zipcode"
              [(ngModel)]="_UserZip" (click)="ClearErrorMessage()"
              (keydown)="onPopupZipKeydown($event)"
              (keypress)="ZipCodeValidate($event)" autocomplete="off" (keyup)="zipCodeLenthInit()" maxlength="5"
              [attr.tabindex]="POPUP_TAB.ZIP" />
            <div class="autopic_location">
              <input type="checkbox" id="search_popup_pick_location" tabindex="-1" aria-hidden="true"
                (change)="GetAutoLocation($event)" />
              <label for="search_popup_pick_location" class="tab-focus popup-location-trigger" data-popup-tab
                [attr.tabindex]="POPUP_TAB.LOCATION" role="button" aria-label="Use my location"
                (keydown)="onPopupLocationKeydown($event)">
                <span></span>
              </label>
            </div>
          </div>
          <!-- <i></i> -->
          <span>{{ ZipCodeMessage }}</span>
        </div>
      </div>
      <div class="find_button btnshover tab-focus" data-popup-tab [attr.tabindex]="POPUP_TAB.FIND" role="button"
        (keydown)="onFindLowestPriceKeydown($event)" (click)="Redirect_LoadPharmacy()">
        Find Lowest Price
      </div>
    </div>
  </div>
</div>

<!-- Enter Quantity Manual Box -->
<div class="change_password quantity_box_manual" *ngIf="ManualQuantity_box">
  <div class="changepassword_main forgot_pass custom_quantity">
    <div class="close_search_pharmacy_popup" (click)="removeforgot($event)"></div>
    <h2>Enter a quantity</h2>
    <div class="input_box">
      <label for="Quantity_Manual">Quantity</label>
      <div class="clearfix">
        <input type="number" id="Quantity_Manual" name="Quantity_Manual" placeholder="0" [(ngModel)]="Quantity_Manual"
          (keypress)="DrugQuantityValidate($event)" />
      </div>
      <span id="Quant_Error">{{ Quantity_error }}</span>
      <div class="clearfix"></div>
      <div class="reset_button" (click)="SubmitQuantity()">Submit</div>
    </div>
  </div>
</div>
<!-- Loader Screen -->
<div class="loaderscreen showloader" *ngIf="showloader">
  <div class="loaderpill">
  </div>
  <div>
    <div class="first"></div>
    <div class="second"></div>
    <div class="third"></div>
    <div class="fourth"></div>
    <div class="fifth"></div>
    <div class="sixth"></div>
    <div class="seventh"></div>
  </div>
</div>

<!--Search pharmacy popup-->
<div class="search_pharmacy_popup no_details_available" *ngIf="ShowNoDetails">
  <div class="search_pharmacy_select">
    <img src="../../assets/images/no-result@1x.svg" alt="" />
    <h2>No details available for this drug.</h2>
    <div class="filter_box">
      <div class="close_search_pharmacy_popup" (click)="CloseNoDetails()"></div>

    </div>
  </div>
</div>